export default __webpack_public_path__ + "media/images/Push_Pin_and_Note-3fd2d5a4a1982d7a3d25f24e85e12552.png";